var _mask, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutlineMoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_654_43661",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4821 3.1132C13.8649 3.38649 13.4704 4 13 4C10.7909 4 9 5.79086 9 8C9 10.2091 10.7909 12 13 12C13.4704 12 13.8649 12.6135 13.4821 12.8868C12.5002 13.5877 11.2983 14 10 14C6.68629 14 4 11.3137 4 8C4 4.68629 6.68629 2 10 2C11.2983 2 12.5002 2.41234 13.4821 3.1132Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4821 12.8868L14.3535 14.1077L13.4821 12.8868ZM10.5 8C10.5 6.61929 11.6193 5.5 13 5.5V2.5C9.96243 2.5 7.5 4.96243 7.5 8H10.5ZM13 10.5C11.6193 10.5 10.5 9.38071 10.5 8H7.5C7.5 11.0376 9.96243 13.5 13 13.5V10.5ZM12.6106 11.6659C11.8747 12.1913 10.9756 12.5 10 12.5V15.5C11.6209 15.5 13.1258 14.9841 14.3535 14.1077L12.6106 11.6659ZM10 12.5C7.51472 12.5 5.5 10.4853 5.5 8H2.5C2.5 12.1421 5.85786 15.5 10 15.5V12.5ZM5.5 8C5.5 5.51472 7.51472 3.5 10 3.5V0.5C5.85786 0.5 2.5 3.85786 2.5 8H5.5ZM10 3.5C10.9756 3.5 11.8747 3.80875 12.6106 4.33406L14.3535 1.89233C13.1258 1.01593 11.6209 0.5 10 0.5V3.5ZM13 13.5C12.6015 13.5 12.3703 13.2764 12.2659 13.0976C12.2025 12.9892 12.1128 12.7769 12.1417 12.4851C12.1752 12.1475 12.3567 11.8472 12.6106 11.6659L14.3535 14.1077C14.7989 13.7898 15.0747 13.3103 15.1271 12.7808C15.175 12.2971 15.0291 11.8802 14.8561 11.5842C14.5325 11.0304 13.8689 10.5 13 10.5V13.5ZM13 5.5C13.8689 5.5 14.5325 4.96965 14.8561 4.4158C15.0291 4.11981 15.175 3.7029 15.1271 3.21922C15.0747 2.68969 14.7989 2.21022 14.3535 1.89233L12.6106 4.33406C12.3567 4.15282 12.1752 3.85253 12.1417 3.5149C12.1128 3.22311 12.2025 3.01082 12.2659 2.90237C12.3703 2.7236 12.6015 2.5 13 2.5V5.5Z",
    fill: "#9DA1B5",
    mask: "url(#path-1-inside-1_654_43661)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlineMoon);
export default __webpack_public_path__ + "static/media/outlineMoon.a268318d4db07c7667b1c5db6cfa0ec0.svg";
export { ForwardRef as ReactComponent };